import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as $ from 'jquery';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AssignedService } from "../../services/frapper/assigned.service";
import { CustomService } from "../../services/frapper/custom.service";
import { DocumentService } from "../../services/frapper/document.service";
import { EnrollementService } from '../../services/frapper/enrollement.service';
import { JugementsService } from "../../services/frapper/jugements.service";
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from "../../services/public/alertes.service";
import { CalendarComponent } from '../../widgets/calendar/calendar.component';
import { AddAssociationPrevenuComponent } from '../add-association-prevenu/add-association-prevenu.component';
import { AddInfractionsComponent } from '../add-infractions/add-infractions.component';
import { AddPieceComponent } from '../add-piece/add-piece.component';
import { DetailsPrevenuComponent } from '../details-prevenu/details-prevenu.component';
import { EditTextComponent } from '../edit-text/edit-text.component';
import { ListNotesComponent } from '../list-notes/list-notes.component';
import { ViewDetailsDossierComponent } from "../view-details-dossier/view-details-dossier.component";
import { VisualiseDecisionComponent } from '../visualise-decision/visualise-decision.component';
import { DossierService } from '../../services/frapper/dossier.service';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
@Component({
  selector: 'app-view-details-jugement',
  templateUrl: './view-details-jugement.component.html',
  styleUrls: ['./view-details-jugement.component.scss']
})
export class ViewDetailsJugementComponent {
  @Input() parentModal: BsModalRef;
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data: any;
  type:any;
  infractions: any;
  objet_jugment:any;
  president_chambre: any;
  assistant_chambre: any;
  concat_tribunal: any = false;
  can_edit_decision: boolean = true;
  is_in_session:any
  audeincesSession:any;
  enrolle:any = {
    "type_daffaire": "Pénale",
    "numero_du_jugement": "None",
    "chambre": "Aucune",
    "date_du_jugement": "None"
  };
  jugement:any;
  modalRef!: BsModalRef;
  selectedInfractions: string[] = [];
  Infractions: any[] = [];
  Amendes: any[] = [];
  Emprisonements: any[] = [];
  ContrainteParCorps: any[] = [];
  affiliations: any[] = [];

  TypeDeCondamnation: any[] = [];
  filtered_TypeDeCondamnation: any[] = [];
  CategorieDeCondamnation: any[] = [];
  is_multiple_prevenu: number ;

  numero_du_jugement=null
  Decision_Judiciaire = null
  Date_decision = null
  Categorie_Decision = null
  showDefault: boolean = true;
  showFactum: boolean = false;
  type_report: string;
  demandeur: string;
  date_report: string;
  raison_report: string;
  prevenusList: any[] = [];
  status_jugement: string = "";
  validation_du_juge =0
  IS_CLOS=0
  decision: string = ""
  categorie: string = ""
  identification_type:any =[];

  label_fact_qualite = "Factas & Qualités"
  label_decisions = "Imprimer décision"
  label_factum = "Factum"
  label_qualite = "Qualités"
  ALLOWED_DECISION_FINAL = false
  SEE_MORE_INFO_JUGEMENT = true
  ALLOWED_SAVE_DECISION = false
  profil
  type_jugement_reports=[
    {name:'Repport pour audience',need_reenrolement:1,is_radiation:0 , is_waiting_deliberation:0},
    {name:'Repport pour vider',need_reenrolement:1,is_radiation:0,is_waiting_deliberation:1},
    {name:'Vider',need_reenrolement:0,is_radiation:0,is_waiting_deliberation:0},
    {name:'Radiation',need_reenrolement:0,is_radiation:1,is_waiting_deliberation:0},
  ]
  my_tribunal:any = null

  jugement_reports=[]
  noMatchVisible: boolean = false;
  isActionVisible: boolean = false;
  searchTerm: string = '';

  default_template = {

    "template_name":"Template vierge",
    "type_de_template": null,
    "flag": "JUGEMENT",
    "image": "https://infomed.sn/wp-content/uploads/2021/05/Justice-860x490.jpg",
    "is_decision": "1",
    "template": "<div>Nouveau template</div>"
}
  CAN_SEE_DOCUMENTS = false
  CAN_SEE_TEMPLATE = false
  CAN_DO_ACTION = true
  CAN_APPROUVE = false
  CAN_CLORE = false
  jugement_name = null

  DOSSIER:any[] = []
  private clefs_template_json = 'assets/data/clefs_template.json';
  CLEFS_TEMPLATES:any = null

  list_template_jugement: any = []
  list_documents: any = []
  jugement_code: any = null
  need_reenrolement=false
  is_radiation =false
  is_waiting_deliberation =false
  constructor(private modalService: BsModalService,public options: ModalOptions,
    private ngxService: NgxUiLoaderService,
    private customerService:CustomService,
    private alerte:AlertesService,
    private assignService:AssignedService,
    private jugementService: JugementsService,
    private documentService: DocumentService,
    private datePipe: DatePipe,
    private http: HttpClient,
    public bsModalRef: BsModalRef,
     private dossierService:DossierService,
    private role:EnrollementService,
    private penalService: PenalCourrierService,private enrollementService: EnrollementService) {
    this.data = options.initialState.data
    this.concat_tribunal = options.initialState.concat_tribunal
    this.is_in_session = options.initialState.is_in_session
    this.audeincesSession = options.initialState.audience_session
    this.objet_jugment = this.data
    this.status_jugement = this.data.status.toLowerCase()
    console.log('JUGEMNT ==> ', this.data)
    console.log('SESSIONAUDIENCES ==> ', this.audeincesSession)
    console.log('isinsession', this.is_in_session );
    
    
    this.jugement_code= this.data.jugement_code
    console.log(this.profil)
    if (this.concat_tribunal == true) {
      this.numero_du_jugement = this.data.numero_du_jugement +'-'+ this.data.tribunal

    }else{
      this.numero_du_jugement = this.data.numero_du_jugement
    }
    this.getClosActions()

    this.profil = localStorage.getItem('profil')

    if (this.profil == "JUGE D\'INSTRUCTION" || this.profil == "GREFFIER D\'INSTRUCTION") {
      this.label_fact_qualite = "Remarques/mise en forme";
      this.label_decisions = "Procé verbale"
      this.label_factum = "Remarques du juge"
      this.label_qualite = "Mise en forme"
    }
    this.getActorOfTheElement()
    this.generateJugementCode()
    try{
      this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))
      //console.log('tribunal_information====> ',tribunal_information)
    }catch (e) {
      console.log('ERROR ON GET TRIBUNAL====> ')
      this.my_tribunal=null
    }

    
    
  }

  

  new_date_report : string;

  generateJugementCode(){
    if(this.jugement_code == '-1'){
      this.jugement_code = this.generateRandomString()
    }
  }

  getFormattedDate(date): string {
    if (date != "None") {
      return this.datePipe.transform(date, 'dd-MM-yyyy');

    }
  }

  async getDataDossier(){
    console.log('getdata', this.data);
    await this.dossierService.getOneDossier(this.data.numero_de_dossier).then((res:any) => {
      this.DOSSIER = res.data
      console.log('DOSSIER=>', this.DOSSIER);
      
    },err=>{
      console.log('ERROR ON getting data dossier ',err)
    })
  }

  closeModal(){
    this.bsModalRef.hide()
  }

  async getDefaultJugementRegistre(){
    this.ngxService.start()
    let result = (await this.jugementService.getDefaultJugementCodeRepertoire(this.enrolle.chambre)).message
    this.data.jugement_code_from_external_registre = result.new_jugement_number
    console.log('numrepertoire-->',result);
    this.ngxService.stop()
   
  }

  async GetTemplateDisponible(){
    console.log('GetTemplateDisponible',this.data);
    
    this.list_template_jugement = []
  // let filter = '[["type_de_template":"'+this.data.classification+'"]]'
    let filter = '[["type_de_template" , "=","' + this.data.classification + '"]]'
    let templates = (await this.documentService.getAllTemplate(filter)).data
    console.log("guetted templates=> ", templates);

    if(templates.length > 0){
      this.list_template_jugement = templates
    }
    this.default_template['type_de_template'] = this.data.classification

    this.list_template_jugement.push(this.default_template)
  }
  async GetDocuments(){
    this.list_documents = []
    console.log('in getDocuments',this.data);
    let jugement_filter =  this.jugement_code;
    console.log('in getDocuments jugementcode',jugement_filter);


   // let filter =this.my_tribunal==null? '[["numero_du_jugement":"'+this.data.numero_de_jugement+'"]]' : '[["numero_du_jugement":"'+this.data.numero_de_jugement+'"],["tribunal" , "=","'+this.my_tribunal.name+'"]]'
    let filter = '[["numero_du_jugement" , "=","' + jugement_filter + '"]]'
    console.log('thefilter in get document',filter);

    let documents = (await this.documentService.getAllDocuments(filter)).data
    console.log('getted docs', documents);

    if(documents.length > 0){
      this.list_documents = documents
    }
    // if(jugement_filter!='-1'){
    //   let documents = (await this.documentService.getAllDocuments(filter)).data
    //   if(documents.length > 0){
    //     this.list_documents = documents
    //   }
    // }

    console.log('in getDocuments', this.list_documents);
  }

  filterValueChange(value){
    this.ngxService.start()
    let result=  (this.type_jugement_reports.filter(obj => obj.name == value))[0]
    console.log(result)
    if(result.need_reenrolement==1){
      this.need_reenrolement =true
    }else {
      this.need_reenrolement =false
    }
    if(result.is_radiation==1){
      this.is_radiation =true
    }else {
      this.is_radiation =false
    }
    if(result.is_waiting_deliberation==1){
      this.is_waiting_deliberation =true
    }else {
      this.is_waiting_deliberation =false
    }
    this.ngxService.stop()
  }

  showFactQuality(){
    this.showFactum = !this.showFactum;
    console.log('kjkjkj'+ this.showFactum);
  }

  removePrefix(path: string): string {
    const segments = path.split('/');
    segments.pop(); // Enlève le dernier segment
    return segments.join('/');
  }
  

  ChangeStatus(){
    this.profil = localStorage.getItem('profil')
    console.log(this.profil)
    console.log(this.data)

    if(
     this.data.status== "Mise en délibéré"
    || this.data.status==  "Decision rendue"
      || this.data.status== "Document généré"
      || this.data.status== "Report"
      || this.data.status==  "Renvoi"
      || this.data.status==  "Radiation"
      || this.data.status== "En appel"
      || this.data.status== "Definitive"
    ){
      if (this.profil.toUpperCase()=='JUGE' || this.profil.toUpperCase()=='JUGE D\'INSTRUCTION') {
        this.CAN_APPROUVE = true
        if(this.data.validation_du_juge!=1){
          this.CAN_APPROUVE = true
        }
        if(this.IS_CLOS==1 ){
          this.CAN_APPROUVE = false
        }
      }
      else if (this.profil.toUpperCase()=='GREFFIER'  || this.profil.toUpperCase()=='GREFFIER D\'INSTRUCTION' ) {
        if(this.data.validation_du_juge==1 &&  this.is_in_session == 1){
          this.CAN_CLORE = true
        }
        if(this.IS_CLOS==1 ){
          this.CAN_CLORE = false
        }
      }
      this.getClosActions()
    }


    if(this.profil.toUpperCase()=='JUGE' || this.profil.toUpperCase()=='GREFFIER'  || this.profil.toUpperCase()=='JUGE D\'INSTRUCTION' || this.profil.toUpperCase()=='GREFFIER D\'INSTRUCTION'){
      
      this.ALLOWED_DECISION_FINAL =true
      this.ALLOWED_SAVE_DECISION = true
      this.CAN_SEE_TEMPLATE = true
      this.CAN_SEE_DOCUMENTS = true

    }else{
      this.ALLOWED_DECISION_FINAL =false
      this.ALLOWED_SAVE_DECISION = false
      this.CAN_SEE_TEMPLATE = false
      this.CAN_SEE_DOCUMENTS = false
      this.SEE_MORE_INFO_JUGEMENT = false;

    }

    // if(this.profil.toUpperCase()=='JUGE'){
    //   this.ALLOWED_DECISION_FINAL =true
    //   this.ALLOWED_SAVE_DECISION = true
    //   this.CAN_SEE_TEMPLATE = true
    //   this.CAN_SEE_DOCUMENTS = true
    // }

    // if(this.profil.toUpperCase()=='GREFFIER'){
    //   this.ALLOWED_DECISION_FINAL =true
    //   this.ALLOWED_SAVE_DECISION = true
    //   this.CAN_SEE_TEMPLATE = true
    //   this.CAN_SEE_DOCUMENTS = true
    // }

    if(this.data.status == "En attente de date du Jugement" ||this.data.status == "Decision rendue" || this.data.status == "En appel" || this.data.status == "Definitive"){
      this.ALLOWED_SAVE_DECISION = false
    }

    if(this.data.status !="Decision rendue" && this.is_in_session == 1){
       this.ALLOWED_DECISION_FINAL = false
     }

    if(this.data.status == "Decision rendue" && this.is_in_session == 1){
      this.CAN_SEE_TEMPLATE = true
      this.CAN_SEE_DOCUMENTS = true
    }


    if(this.data.status != "Decision rendue"  && this.data.status != "Definitive" && this.is_in_session == 1 ){
      this.CAN_SEE_TEMPLATE = false
      this.CAN_SEE_DOCUMENTS = false
    }
    if(this.data.status == "En appel"){
      //this.CAN_SEE_TEMPLATE = true
      this.CAN_SEE_DOCUMENTS = true
    }
    if (this.data.status=='Document généré') {
      this.CAN_SEE_TEMPLATE = false
    }
    this.data.status.toLowerCase() == 'document généré' ? false: true
    if(this.data.status=='Report' || this.data.status=='Radiation'  || this.data.status=='Renvoi'){
      this.CAN_DO_ACTION =false
    }



  }

  selectTypePrevenu(event: any){

    const isChecked = event.target.checked;
    if (isChecked) {
      this.is_multiple_prevenu = 1;
    }else{
      this.is_multiple_prevenu = 0;
    }
    console.log('is_multiple_prevenu==>',this.is_multiple_prevenu);


}
  generateRandomString(): any {
    const length =10;
    const characters = '0123456789';
    let result = '';
    let currentDate = new Date();
    let currentYear= currentDate.getFullYear();

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

   return  currentYear +'/'+ result;
  }




  UpdateDecision(){
    console.log('uhijo',this.data );

    this.ngxService.start()
    if(this.CAN_DO_ACTION == false){
      this.alerte.warningNotification('Impossible d\'effectuer des operations sur cette audience: audience reportée ou radiée')
      this.ngxService.stop()
    }else{
      let table_tqhi =this.ContrainteParCorps
      let table_emp =this.Emprisonements
      let table_amendes_j =this.Amendes

      for(let lg of this.lignes){
        let to_add ={
          "docstatus": 1,
          "debut": lg.debut,
          "fin": lg.fin,
          "main_leve": lg.main_leve,
          "parent": this.data.name,
          "parentfield": "table_tqhi",
          "parenttype": "Jugements",
          "doctype": "fiche_a_classer_contrainte_par_corps"
        }
        table_tqhi.push(to_add)
      }
      for(let lg of this.lignes_condamenations){
        let to_add ={
          "docstatus": 1,
          "type": lg.type,
          "durée": lg['durée'],
          "périodicité": lg['périodicité'],
          "parent": this.data.name,
          "parentfield": "table_emp",
          "parenttype": "Jugements",
          "doctype": "fiche_a_classer_emprisonement"
        }
        table_emp.push(to_add)
      }
      for(let lg of this.lignes_ammendes){
        let to_add ={
          "docstatus": 1,
          "montant": lg.montant,
          "aux_depens_liquides_a_la_somme": lg.aux_depens_liquides_a_la_somme,
          "parent": this.data.name,
          "parentfield": "table_amendes_j",
          "parenttype": "Jugements",
          "doctype": "fiche_a_classer_amende"
        }
        table_amendes_j.push(to_add)
      }

      let body ={
        "status": "Decision rendue",
        "date_de_decision":this.Date_decision,
        "jugement_code_from_external_registre": this.data.jugement_code_from_external_registre,
        "categorie_de_la_decision":this.Categorie_Decision,
        "decision_judiciaire":this.Decision_Judiciaire,
        "jugement_code": this.jugement_code +'/'+this.my_tribunal.name,
        table_tqhi,table_emp,table_amendes_j
      }
      console.log('bodyyyy->',body);
      if (this.Date_decision == null || this.Decision_Judiciaire== null || this.data.jugement_code_from_external_registre == null) {
        this.alerte.errorNotification('informations manquantes', 'Veuillez renseigner les champs obligatoires');
        this.ngxService.stop();
        return;
        
      }

      this.jugementService.updateJugement(this.data.name,body).then(async res =>{
        // this.list_documents=[]
        console.log('REsultatand ==> ',res)
        this.jugement_code = res.data.jugement_code
        this.data.jugement_code = this.jugement_code
        this.objet_jugment = this.data
        console.log('REsultatand data ==> ',this.data)

        console.log('the jugment_code ==> ',this.jugement_code)

        try{
          this.enrolle['status'] = "Decision rendue"
          this.enrolle["jugement_code_from_external_registre"] = this.data.jugement_code_from_external_registre,
          this.enrolle['jugement_code'] = res.data.jugement_code
          this.role.updateRole(this.enrolle.name,this.enrolle).then(async res=>{
            await this.role.getAllRoleGeneral('[["identifiant_e_role" , "=","'+this.enrolle.name+'"]]').then(res=>{
              console.log('res======> ',res)
              let role_general = res.data[0]
              role_general['status'] = "Decision rendue"
              role_general["jugement_code_from_external_registre"] = this.data.jugement_code_from_external_registre,
              role_general['jugement_code'] =  this.jugement_code,
              role_general['decision'] = this.Decision_Judiciaire
              console.log('res======> ',role_general)
              this.role.updateRoleGeneral(role_general.name,role_general)
              // this.list_documents=[]
              this.ngxService.stop();
            },err=>{
              this.ngxService.stop();
            })
          })
        }catch (e) {

        }

        this.openModalSuccessDialog('Sauvegarde effective',1)
       await this.jugementService.getOneJugement(this.data.name).then(res =>{
          //console.log(res)
          this.ChangeStatus()
          this.data=res.data
          this.Infractions = res.data.table_infractions
          this.Amendes = res.data.table_amendes_j
          this.Emprisonements = res.data.table_emp
          this.ContrainteParCorps = res.data.table_tqhi
          this.affiliations = res.data.affiliations
          this.jugement_reports = res.data.jugement_reports
          this.ngxService.stop()
        })
        this.getJugement()

      },err=>{
        console.log('Errue ==> ',err)
        this.alerte.errorNotification('Décision','Erreur lors de la mise à jour! Verifier que vous avez les autorisations requises')
        this.ngxService.stop()
      })
    }
    console.log('listdocssssss',this.list_documents );


  }

  UpdateFinalStatus(value,is_sate=0){
    this.ngxService.start()

    let body:any = {
      "status": value
    }
    if(is_sate==1){
      if(this.profil=='JUGE' || this.profil=='JUGE D\'INSTRUCTION'){
        body= {
          "validation_du_juge":1
        }
      }
      if(this.profil=='GREFFIER'|| this.profil=='GREFFIER D\'INSTRUCTION'){
        body = {
          "is_clos":1
        }
      }
      if(this.profil=='GREFFIER EN CHEF'){
        body = {
          "is_clos":1
        }
      }
    }

    this.jugementService.updateJugement(this.data.name,body).then(res =>{
      console.log('REsultat ==> ',res)
      this.openModalSuccessDialog('Mise a jour effective',1)
      this.jugementService.getOneJugement(this.data.name).then(res =>{
        //console.log(res)
        this.data=res.data
        this.Infractions = res.data.table_infractions
        this.Amendes = res.data.table_amendes_j
        this.Emprisonements = res.data.table_emp
        this.ContrainteParCorps = res.data.table_tqhi
        this.affiliations = res.data.affiliations
        this.jugement_reports = res.data.jugement_reports
        this.ChangeStatus()
        this.bsModalRef.hide()
        this.ngxService.stop()
      })
    },err=>{
      console.log('Errue ==> ',err)
      this.alerte.errorNotification('Miser ajour','Erreur lors de la mise à jour')
      this.ngxService.stop()
    })

  }



  async getAllChambres(chambre_:string) {
    //this.chambres = this.penalService.getChambres();

    this.ngxService.start();
    try {
     let chambres  = (await this.enrollementService.getAllMyChambre()).data
      const chambreRecherchee = chambres.find(chambre => chambre.name === chambre_);

      this.ngxService.stop();

      return chambreRecherchee
    } catch (error) {
      this.ngxService.stop();
    }

    //console.log({'the result': result});

  }

  async openModalCalendar(dataEnrole: any) {
    // let courrier:any = this.courriers[id];
    // this.penalService.setSelectedChambre(chambre);

    console.log({'data enrolle': dataEnrole});

    let _chambre = await this.getAllChambres(dataEnrole.chambre)
    console.log({'in search': _chambre});
    let v = this.penalService.setSelectedChambre(_chambre);
    console.log('details detail chmbre === '+ v);

    const config: ModalOptions = {
      ignoreBackdropClick:true,
      initialState: {
        data: dataEnrole,
        type:'report',
        parentModal: null
    }
     }
    const modalRef = this.modalService.show(CalendarComponent, Object.assign({},config,{class:'modal-lg  '}));
    modalRef.content.parentModal = modalRef;
    const calendarComponent = modalRef.content as CalendarComponent;
    calendarComponent.dateSelected.subscribe((selectedDate: string) => {
      this.new_date_report = selectedDate; // Mettre à jour la date dans votre composant parent
      console.log('outpuutttttdate'+ this.new_date_report);

    });

  }

  openModalAddPrevenu() {
    const config: ModalOptions = {
      ignoreBackdropClick:true,
      initialState: {
        url:URL,
        parentModal : null
      }
    }

    // Ouvrir le modal
    let modalRef = this.modalService.show(AddAssociationPrevenuComponent, Object.assign({}, config, { class: 'modal-lg  ' }));

    modalRef.content.newPrevenuAdded.subscribe((newPrevenu: any) => {
      console.log('Nouveau prévenu ajouté :', newPrevenu);
      this.prevenusList.push(newPrevenu);

    });
  }


  openModalDetailsPrevenu(prevenu:any) {
    const config: ModalOptions = {
      ignoreBackdropClick:true,
      initialState: {
        url:URL,
        data: prevenu,
        parentModal : null
      }
    }

    // Ouvrir le modal
    let modalRef = this.modalService.show(DetailsPrevenuComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    modalRef.content.newPrevenuAdded.subscribe((newPrevenu: any) => {

      let existingPrevenuIndex = this.prevenusList.find(p => p === prevenu);
      if (existingPrevenuIndex != null) {
        existingPrevenuIndex = newPrevenu;
      }

      console.log('findeddd :', existingPrevenuIndex);
      // this.prevenusList.push(newPrevenu);

    });
  }
  deletePrevenu(prevenu:any){
    let existingPrevenuIndex = this.prevenusList.find(p => p === prevenu);
    this.prevenusList.splice(existingPrevenuIndex, 1)

  }
  openModalSuccessDialog(message: string, not_close=0) {
    const config: ModalOptions = {
      initialState: {
        message: message
      }
    };
  
    this.alerte.successNotification('Audience',message)
    // this.modalRef = this.modalService.show(SuccessDialogComponent, Object.assign({}, config, {class:'modal-sm'}));
  }

  savePersonalInformation(form){
    this.ngxService.start()
    //console.log(form.value)

    form.value['is_multiple_prevenu'] = this.is_multiple_prevenu
    form.value['association_de_prevenu'] = this.prevenusList
    let body =form.value
    console.log({'updateJugement': body});

    this.jugementService.updateJugement(this.data.name,body).then(res =>{
      //console.log('REsultat ==> ',res)
      let jugement_name = this.numero_du_jugement ==null ? this.data.name: this.numero_du_jugement
      this.jugementService.getOneJugement(jugement_name).then(res =>{
        //console.log(res)
        this.ChangeStatus()
        this.data=res.data
        this.Infractions = res.data.table_infractions
        this.Amendes = res.data.table_amendes_j
        this.Emprisonements = res.data.table_emp
        this.ContrainteParCorps = res.data.table_tqhi
        this.affiliations = res.data.affiliations
        this.jugement_reports = res.data.jugement_reports

        this.Categorie_Decision = res.data.categorie_de_la_decision
        this.Decision_Judiciaire  = res.data.decision_judiciaire


        this.getDetailEnrolleJugement()
      })
      this.openModalSuccessDialog('Sauvegarde effective',1)
      this.ngxService.stop()

    },err=>{
      console.log('Errue ==> ',err)
      this.alerte.errorNotification('Information Justiciable','Erreur lors de la mise a jours')
      this.ngxService.stop()
    })

  }

  updateJugementRepport(form){
    this.ngxService.start()
    let nouvel_date= ''
    if (this.new_date_report != null) {
      const parts = this.new_date_report.split('/');
    const formattedDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    const formattedDateString = this.datePipe.transform(formattedDate, 'yyyy-MM-dd');

    console.log('formattedDateString ==> ',formattedDateString)
      nouvel_date= formattedDateString
    form.value['nouvelle_date'] = formattedDateString
    }

    //console.log(form.value)


    this.jugement_reports.push(form.value)
    let body = {jugement_reports:this.jugement_reports}
    if(this.need_reenrolement){
      // body["status"]= "Report"
      body["status"]= "Renvoi"

    }
    if(this.is_radiation){
      body["status"]= "Radiation"
    }
    if(this.is_waiting_deliberation){
      body["status"]= "Mise en délibéré"
    }

    this.jugement_reports =[]
    this.jugementService.updateJugement(this.data.name,body).then(res =>{
      //console.log('REsultat ==> ',res)
      let jugement_name = this.numero_du_jugement ==null ? this.data.name: this.numero_du_jugement

      if (this.new_date_report != null) {
         res.data.date_de_jugement=nouvel_date
        this.createnewAudience(res.data,res.data.status,nouvel_date,1).then(res =>{

          this.jugementService.getOneJugement(jugement_name).then(res =>{
            //console.log(res)
            this.ChangeStatus()
            this.data=res.data
            this.Infractions = res.data.table_infractions
            this.Amendes = res.data.table_amendes_j
            this.Emprisonements = res.data.table_emp
            this.ContrainteParCorps = res.data.table_tqhi
            this.affiliations = res.data.affiliations
            this.jugement_reports = res.data.jugement_reports

            this.Categorie_Decision = res.data.categorie_de_la_decision
            this.Decision_Judiciaire  = res.data.decision_judiciaire


            // this.getDetailEnrolleJugement()
            this.getJugement()
          })


          this.openModalSuccessDialog('Operation Effectue avec success !',0)
          this.ngxService.stop()
        },err => {
          this.alerte.errorNotification('Error')
          console.log('err ==> ',err)
          this.ngxService.stop()
        })
      }else{
        this.jugementService.getOneJugement(jugement_name).then(res =>{
          //console.log(res)
          this.ChangeStatus()
          this.data=res.data
          this.Infractions = res.data.table_infractions
          this.Amendes = res.data.table_amendes_j
          this.Emprisonements = res.data.table_emp
          this.ContrainteParCorps = res.data.table_tqhi
          this.affiliations = res.data.affiliations
          this.jugement_reports = res.data.jugement_reports

          this.Categorie_Decision = res.data.categorie_de_la_decision
          this.Decision_Judiciaire  = res.data.decision_judiciaire


          this.getDetailEnrolleJugement()
        })
        this.openModalSuccessDialog('Operation Effectue avec success !',1)
        this.ngxService.stop()
      }




    },
        err=>{
      console.log('Errue ==> ',err)
      this.alerte.errorNotification('Information Justiciable','Erreur lors de la mise a jours')
      this.ngxService.stop()
    })
  }


  async createnewAudience(body_jugement,status_role,new_date,is_report=0){
    let next_number_corrier:any = {}
    this.role.getnumeroRole().then( res =>{
      console.log('Numero role ==> ',res.message)
      next_number_corrier = res.message
      // console.log('---> ',this.next_number_corrier)
      body_jugement["nbr_repport"] =is_report==1? body_jugement["nbr_repport"]+1 : body_jugement["nbr_repport"]
      body_jugement["numero_de_jugement"] = is_report==1?body_jugement["numero_de_jugement"] :next_number_corrier.new_role_number
      body_jugement["status"] = "En attente du Jugement"
      body_jugement["is_new_role"] = 0


      delete body_jugement ['owner'];
      delete body_jugement ['creation'];
      delete body_jugement ['modified'];
      delete body_jugement ['modified_by'];

      body_jugement["date_de_decision"] =""

      this.jugementService.nouveauJugement(body_jugement).then( (res:any)=> {
          console.log('Create Jugement !', res.data)
          let audience = res.data
          let body_role ={
            "docstatus": 1,
            "type_daffaire": this.enrolle.type_daffaire,
            "numero_du_jugement": res.data.numero_de_jugement,
            "numero_du_jugement_restrint":res.data.numero_de_jugement,
            "audience":res.data.name,
            "num_quittance1":this.enrolle.num_quittance1,
            "num_quittance2":this.enrolle.num_quittance2,
            "chambre": this.enrolle.chambre,
            "date_du_jugement": new_date
          }
          if(this.my_tribunal!=null){
            body_role['tribunal']=this.my_tribunal.name
          }

          this.role.nouveauRole(body_role).then(res =>{
              // console.log('RES ==> ',res)
              let body_role_general= body_role
              body_role_general["identifiant_e_role"] = res.data.name
              body_role_general["numero_du_role"] = res.data.numero_du_jugement_restrint
              body_role_general["plaignants"] = body_jugement.nom_complet_plaignant
              body_role_general["prevenue"] = body_jugement.prenom
              try {
                 this.role.addInRoleGeneral(body_role_general).then(res=>{})
              }catch (e) {

              }
              console.log('Create new role !', res.data)
              let role_info = res
              let detail_chambre=null
              try{
                 this.jugementService.updateJugement(audience.name,{"role":role_info.data.name})
              }catch (e) {

              }
              this.role.getOneChambre(this.enrolle.chambre).then(res=>{
                //console.log('res.data ==> ',res.data)
                detail_chambre=res.data
                let membres = detail_chambre.membres
                //console.log('membres (utilisateur) ==> ',membres)
                for(let membre of membres){
                  this.assignService.doAssignation(this.jugementService.Doctype_jugements,audience.name,[membre.utilisateur]).then(res=>{})
                  this.assignService.doAssignation(this.role.Doctype_enrolement,role_info.data.name,[membre.utilisateur]).then(res=>{})
                }
                for(let membre of this.alloed_user_acces){
                  this.assignService.doAssignation(this.jugementService.Doctype_jugements,audience.name,[membre]).then(res=>{})
                  this.assignService.doAssignation(this.role.Doctype_enrolement,role_info.data.name,[membre]).then(res=>{})
                }

              })

              this.enrolle['status'] = status_role
              this.role.updateRole(this.enrolle.name,this.enrolle).then(res=>{})
              this.role.getAllRoleGeneral('[["identifiant_e_role" , "=","'+this.enrolle.name+'"]]').then(res=>{
                let role_general = res.data[0]
                role_general['status'] = status_role
                role_general['jugement_code'] =  this.jugement_code,
                console.log('res======> ',role_general)
                this.role.updateRoleGeneral(role_general.name,role_general)
                this.ngxService.stop();
              },err=>{
                this.ngxService.stop();
              })
            },
            err=>{
              console.log('Error Creation de role ==> ',err)
              this.alerte.errorNotification('Creation du Role','Impossible d\'effectuer l\'enrollement')
              this.ngxService.stop();
            })
        },
        (error:any)=> {
          this.alerte.errorNotification('Creation du Role','Impossible d\'effectuer l\'enrollement')
          this.ngxService.stop();
          console.log('Error on creaste Jugement !', error)
        }
      )
    },err=>{
      console.log('ERR==> ',err)
      this.alerte.errorNotification('Erreur')
    })

  }

  async getDetailEnrolleJugement() {
    try {
      let filter = null
      if(this.data.role==null ){
         filter = '[["numero_du_jugement" , "=","' + this.data.numero_de_jugement + '"]]'
      }else {
         filter = '[["name" , "=","' + this.data.role + '"]]'
      }

      //this.enrolle = this.penalService._Dossiersenrolles.find(objet => objet.numero === 'AR-01-2024');
      this.enrolle = (await this.role.getAllMyRole(filter)).data[0]
      this.getDefaultJugementRegistre()
      // get dossier et jsons pour les clefs templates
      if (this.CLEFS_TEMPLATES == null) {
        this.getDataDossier().then(()=>{
          this.getClefsTemplateData().subscribe((res)=>{
            console.log('thejson=>',this.CLEFS_TEMPLATES);
            this.clefs_template_json = res
            console.log('clefs_template_json=>',  this.CLEFS_TEMPLATES);
            this.CLEFS_TEMPLATES = this.replaceValuesClefsTemplate(this.clefs_template_json);
              console.log('thecompletjson=>',  this.CLEFS_TEMPLATES);
            
    
            
            
          })
        })
      }
     
      console.log('E-ROLE=>',this.data);
      console.log('llljjj===> ',this.enrolle);
    } catch (error) {
      console.log('error getdetailsenrollement ===> ',error);
    }

  }

  alloed_user_acces:any =[]

  getClosActions(){
    if(
      this.data.status== "Mise en délibéré"
      || this.data.status==  "Decision rendue"
      || this.data.status== "Document généré"
      || this.data.status== "Report"
      || this.data.status==  "Renvoi"
      || this.data.status==  "Radiation"
      || this.data.status== "En appel"
      || this.data.status== "Definitive"
    ){
      if(this.profil=='JUGE'){
        this.CAN_CLORE =false
        if(this.data.validation_du_juge==0 && this.IS_CLOS==0 && this.is_in_session == 1){
          this.CAN_APPROUVE =true
        }
      }

      if(this.profil=='JUGE D\'INSTRUCTION'){
        this.CAN_CLORE =false
        if(this.data.validation_du_juge==0 && this.IS_CLOS==0 && this.is_in_session == 1){
          this.CAN_APPROUVE =true
        }
      }

      if(this.profil=='GREFFIER EN CHEF' &&  this.is_in_session == 1){
        this.CAN_APPROUVE =false
        if(this.data.validation_du_juge==1 && this.IS_CLOS==0 && this.is_in_session == 1){
          this.CAN_CLORE =true
        }
      }
      if(this.profil=='GREFFIER'){
        this.CAN_APPROUVE =false
        if(this.data.validation_du_juge==1 && this.IS_CLOS==0 && this.is_in_session == 1){
          this.CAN_CLORE =true
        }
     
      }

      if(this.profil=='GREFFIER D\'INSTRUCTION'){
        this.CAN_APPROUVE =false
        if(this.data.validation_du_juge==1 && this.IS_CLOS==0 && this.is_in_session == 1){
          this.CAN_CLORE =true
        }
     
      }
    }


  }
  async getActorOfTheElement(){
    let Users =[]
    this.assignService.getAssignedAnOwnerUser('Dossier',this.data.numero_de_dossier).then(res=>{
      if (res != null) {
        console.log('res ==> ',res?.message[0])
        let data:any = res?.message[0]
        let alloed_user_acces:any = JSON.parse(data["_assign"])
        let owner = data["owner"]
        alloed_user_acces.push(owner)
        this.alloed_user_acces = alloed_user_acces
        console.log( '1 ==> ', this.alloed_user_acces)
      }

      //console.log( '2 ==> ', owner)

    })
  }

  openModalDetailDossier(data:any) {
    // let courrier:any = this.courriers[id];
    // console.log('details === '+ courrier);

    const config: ModalOptions = {
      ignoreBackdropClick:true,
      backdrop: true,
      initialState: {
        data: data
      }
    }
    const modalRef  = this.modalService.show(ViewDetailsDossierComponent, Object.assign({},config,{class:'modal-xl  '}));

  }


  async getTypeOfCondamnation(){
    this.TypeDeCondamnation = (await this.jugementService.getAllCondamnationType()).data
    this.filtered_TypeDeCondamnation = [...this.TypeDeCondamnation]

   console.log('condamnationnnn-->',this.TypeDeCondamnation)
  }
  async getCateggorieOfCondamnation(){
    this.CategorieDeCondamnation = (await this.jugementService.getAllCondamnationCategorie()).data
    // console.log(this.TypeDeCondamnation)
  }

  UpdateCategoriCondoamnatione(value){
    this.Categorie_Decision = value
    console.log(this.Categorie_Decision)
  }
  UpdateTypeCondamnation(value){
    this.Decision_Judiciaire = value
   // console.log(this.Decision_Judiciaire)
  }
  UpdateDatedeDecision(value){
    this.Date_decision = value
  }

  lignes: any[] = [];
   indexRow = 2;

  ajouterLigne() {
    this.lignes.push({id:this.indexRow++, colonne1: '', colonne2: '' });
  }
  // condamenation
  lignes_condamenations: any[] = [];
   indexRow_cond = 2;

  ajouterLigne_condamnation() {
    this.lignes_condamenations.push({id:this.indexRow_cond++, colonne1: '', colonne2: '' });
  }

  optionsSelect: string[] = ['Ferme', 'Sursis'];
  periodicite: string[] = ['An(s)', 'Mois', 'Jour(s)'];

  // ammendements
  lignes_ammendes: any[] = [];
   indexRow_ammende = 2;

  ajouterLigne_ammendements() {
    this.lignes_ammendes.push({id:this.indexRow_ammende++, colonne1: '', colonne2: '' });

  }

  deleteInfraction(infraction: any){
    this.selectedInfractions = this.selectedInfractions.filter(item => item != infraction);


  }

  deleteContrainte(element: any){
    this.lignes = this.lignes.filter(item => item != element);
  }

  deleteEmprisonnement(element: any){
    this.lignes_condamenations = this.lignes_condamenations.filter(item => item != element);
  }

  deleteAmmendes(element: any){
    this.lignes_ammendes = this.lignes_ammendes.filter(item => item != element);
  }


  async getAllInfrations() {
    this.ngxService.start();
    try {
      this.infractions = (await this.enrollementService.getAllInfractions()).data
      this.ngxService.stop();

    } catch (error) {
      this.ngxService.stop();
    }

  }

  toggleSelection(infraction: string): void {
    if (this.infractions.includes(infraction)) {
      this.selectedInfractions = this.selectedInfractions.filter(item => item !== infraction);
    } else {
      this.selectedInfractions.push(infraction);
    }
  }

  openModalAddPiece() {

    const config: ModalOptions = {
      ignoreBackdropClick:true,
      initialState: {
        // message: message
      }
    };
    // this.penalService.hiddeModal(this.parentModal);
    this.modalRef = this.modalService.show(AddPieceComponent, Object.assign({}, config, {class:'modal-lg '}));
  }

  openModalEditText(data: any) {
    let is_editable = false ;
    if (this.status_jugement.toLocaleLowerCase() !== 'renvoi' && this.status_jugement.toLocaleLowerCase() !== 'report' && this.status_jugement.toLocaleLowerCase() !== 'definitive') {
      is_editable = this.IS_CLOS == 0 &&   this.is_in_session != null ?true: false
    }
    const config: ModalOptions = {
      ignoreBackdropClick:true,
      initialState: {
        // message: message
        is_editable : is_editable,
        data: data,
        parentModal: null
      }
    };
    // this.penalService.hiddeModal(this.parentModal);
    this.modalRef = this.modalService.show(EditTextComponent, Object.assign({}, config, {class:'modal-xl '}));
    this.modalRef.content.parentModal = this.modalRef;
  }

  openModalListNotes(audience: any) {

    const config: ModalOptions = {
      ignoreBackdropClick:true,
      initialState: {
        // message: message
        doctype: this.jugementService.Doctype_jugements,
        num_audience: audience.name,
        can_add:this.IS_CLOS == 1? false: null
        // parentModal: null
      }
    };
    // this.penalService.hiddeModal(this.parentModal);
    // this.modalRef = this.modalService.show(WhiteboardCanvasComponent, Object.assign({}, config, {class:'modal-xl '}));
    let openmodal = this.modalService.show(ListNotesComponent, Object.assign({}, config, {class:'modal-xl'}));

    // this.modalRef.content.parentModal = this.modalRef;
  }

  hidde() {
    if (this.modalService) {
      this.modalService.hide();
    }
  }

  initializeStepper() {
    console.log('innnnn ssteppp 31  '+this.type );
    var stepFirst = this.type;

    $(document).ready(function(){
      var current_fs, next_fs, previous_fs; //fieldsets
      var opacity;
      var current = 1;
      var steps = $("fieldset").length;


      setProgressBar(current);



      if (stepFirst == 'step3') {
        console.log('in step333 === '+ stepFirst);


        $("fieldset.step1").hide();
        $("fieldset#step1").addClass("active");
        $("fieldset.step2").hide();
        $("#step2").addClass("active");
          // Afficher le fieldset de classe step3
          $("fieldset.step3").show();
        // $("fieldset").eq(2).show();
        current = 4;
        setProgressBar(current++);

        // Ajouter la classe "active" au deuxième élément de la barre de progression
        $("#progressbar li").eq(2).addClass("active");
        console.log("Au moins un élément fieldset a la classe 'cache'");
      }


      // Fonction pour définir la barre de progression
      function setProgressBar(curStep){
          var percent = (100 / steps) * curStep;
          percent = percent
          $(".progress-bar").css("width",percent+"%");
      }

      // Logique pour passer à l'étape suivante
      $(".next").click(function(){
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  next_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(++current);
      });

      // Logique pour revenir à l'étape précédente
      $(".previous").click(function(){
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  previous_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(--current);
      });
  });

  }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }
  
  // Methode pour recuperer les donnees du fichier JSON
  getClefsTemplateData(): Observable<any> {
    console.log('Loading clefs template JSON from:', this.clefs_template_json);
    
    return this.http.get<any>(this.clefs_template_json).pipe(
      catchError(error => {
        console.error('Erreur lors du chargement du fichier JSON', error);
        return of(null); // Retourne une valeur par défaut en cas d'erreur
      })
    );
  }

  replaceValuesClefsTemplate(fichier_json:any) {
    console.log('replaceValuesClefsTemplate called with:', fichier_json);
    console.log('can see template:', this.CAN_SEE_TEMPLATE);
    
    const result = {};
  
    console.log('Keys in fichier_json:',fichier_json);
    
    for (const key in fichier_json) {
      //console.log('KEY -----> ', key)
      if (fichier_json.hasOwnProperty(key)) {
        const path = fichier_json[key];
  
        // separer la partie avant le premier point et le reste
        const keys_ = path.split("."); // 0 = doctype , 1 key in doctype ,n key in object 
       
        // const [source, ...keys] = path.split(".");
  
        let value = null;
  
        let object_to_use = keys_[0]=="dossier"? this.DOSSIER:  keys_[0]=="audiences"? this.data:  keys_[0]=="audiencesession"? this.audeincesSession: keys_[0]=="erole"? this.enrolle: null

        if(object_to_use != null && keys_[1].includes("[]")){
      
          let val_array:any = object_to_use[keys_[1].replace("[]", "")]

          for (let i = 0; i < val_array.length; i++) {
            let val = val_array[i];
            let isLast = i === val_array.length - 1; 
          
            isLast? (value = val[keys_[2]] + " "):value = val[keys_[2]] + " , "
           
          
            console.log('val ----> ', val.name);
            console.log('value ----> ', value);
          }
          
        }else{
          if (object_to_use != null) {
            value = object_to_use[keys_[1]]

          }
        }

        result[key] = value;
      }
    }
  
    return result;
  }


  async openModalVisualDecision(data: any,template:any,is_document=0,is_qualite=false) {

    const config: ModalOptions = {
      backdrop: true,
      initialState: {
        data: this.CLEFS_TEMPLATES,
        data_template: template,
        is_document:is_document,
        type_doctype: this.jugementService.Doctype_jugements,
        is_qualite: is_qualite,
        is_editable: ((this.profil != 'GREFFIER' && this.profil != 'GREFFIER D\'INSTRUCTION') || this.IS_CLOS == 1) ? false:true
      }
    }

    if (this.profil != 'GREFFIER' && this.profil != 'GREFFIER D\'INSTRUCTION') {
      this.alerte.warningNotification('Qualités jugement',"Les qualités ne sont editable que par un greffier")
    }
    console.log('gdgdgdg',config.initialState);
    

     //Ouvrir le modal   ViewDetailsCourrierComponent
     return new Promise<string>((resolve, reject) => {
      this.modalRef = this.modalService.show(VisualiseDecisionComponent, Object.assign({}, config, {class:'modal-xl '}));
      this.modalRef.content.parentModal = this.modalRef;
      this.modalRef.onHidden.subscribe(async (value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
        if ( value == "success") {

          // this.closeWithMessage("")

          try {
            this.jugementService.getOneJugement(this.jugement_name).then(async res => {
                  
              this.data = res.data;
              this.CLEFS_TEMPLATES = this.replaceValuesClefsTemplate(this.clefs_template_json);
      
           })
          } catch (error) {
            console.log(error);
            
          }
          // await this.GetDocuments()
          // await this.getJugement()
          this.data['status'] = 'Document généré';
          this.CAN_SEE_TEMPLATE = false

       }


      });
    }).then(async (value: string) => {

    });

     // Mettre à jour l'option initialState avec le modalRef
  }

  active_edit_decision(){
    this.can_edit_decision = !this.can_edit_decision
    this.ALLOWED_SAVE_DECISION = true
  }

  onSaveClicked(type: string) {
    console.log('Save button clicked from EditText with type:', type);
    try {
      this.jugementService.getOneJugement(this.jugement_name).then(async res => {
            
        this.data = res.data;
        this.CLEFS_TEMPLATES = this.replaceValuesClefsTemplate(this.clefs_template_json);
     })
    } catch (error) {
      console.log(error);
      
    }
  
  }

  async getJugement() {
    console.log('init data ===> ', this.data);
    this.ngxService.start()
    // let jugement_name = this.numero_du_jugement == null ? this.data.name : this.numero_du_jugement;
    // if (this.data.audience) {
    //   jugement_name = this.data.audience
    // }
    this.jugement_name = this.numero_du_jugement == null ? this.data.name : this.numero_du_jugement;
    if (this.data.audience) {
      this.jugement_name = this.data.audience
    }
    // console.log('num proce ===> ', jugement_name);
    // console.log('num proce jugement_name ===> ', jugement_name);

    const fetchJugement = async () => {
        return await this.jugementService.getOneJugement(this.jugement_name).then(async res => {
            
            this.data = res.data;
            console.log('AUDIENCES=>',this.data);
            this.GetTemplateDisponible()
           
            this.IS_CLOS=this.data.is_clos != null ? this.data.is_clos : 0
            this.ChangeStatus();
            console.log('num proce ===> ', this.data);
            console.log('value is_clos ===> ', this.IS_CLOS);
            this.status_jugement = this.data.status.toLowerCase();
            this.is_multiple_prevenu = this.data['is_multiple_prevenu'];
            this.prevenusList = this.data['association_de_prevenu'];

            this.Infractions = res.data.table_infractions;
            this.Amendes = res.data.table_amendes_j;
            this.Emprisonements = res.data.table_emp;
            this.ContrainteParCorps = res.data.table_tqhi;
            this.affiliations = res.data.affiliations;
            this.jugement_reports = res.data.jugement_reports;
            console.log('jugements report===> ', this.jugement_reports);

            this.Categorie_Decision = res.data.categorie_de_la_decision;
            this.Decision_Judiciaire = res.data.decision_judiciaire;
            if (this.Decision_Judiciaire != undefined && this.Decision_Judiciaire.toLowerCase() !== 'en attente de date du jugement' && this.Decision_Judiciaire.toLowerCase() !== 'Definitive' ) {
              this.can_edit_decision = false;
            }

           await this.getDetailEnrolleJugement();
        });

    };

    fetchJugement().catch(err => {
        console.log('GET JUGEMENT ERROR ==> ', err);
        // this.alerte.errorNotification('Un problème est survenu lors de la première tentative. Nouvelle tentative...');
        this.numero_du_jugement = this.data.numero_du_jugement
        this.jugement_name =  this.numero_du_jugement
        // Relancer une deuxieme requete sans concatenation avec le tribunal
        fetchJugement().catch(err => {
            console.log('GET JUGEMENT ERROR (2ème tentative) ==> ', err);
            // this.modalRef.hide()
            this.bsModalRef.hide()
            this.alerte.errorNotification('cette audience n\'existe pas!');

        });
    });
    

    if (this.is_in_session == null ) {
      this.data.id_session_audience != null||undefined? this.is_in_session = 1 : this.is_in_session = null;

      console.log('theidsession_audience', this.is_in_session);
      
    }
    this.ngxService.stop()
}

  async refresh(){
    this.ngxService.start()
    try {
      this.getJugement()

    this.jugementService.getAllTypeRepports().then(res=>{
      this.type_jugement_reports = res.data
    })

    this.GetTemplateDisponible()
    this.GetDocuments()

    this.getTypeOfCondamnation()
    this.getCateggorieOfCondamnation()

    await this.getAllInfrations()
    } catch (error) { 

    }
    this.ngxService.stop()


  }

  onFocus(inputId: string): void {
    this.loadAllProfiles(inputId); // Charge les profils lorsque l'input reçoit le focus
    this.isActionVisible = true; // Affiche la liste quand l'input reçoit le focus
  }

  // Gérer l'événement blur sur l'input
  onBlur(inputId: string): void {
    setTimeout(() => {
      this.isActionVisible = false; 
    }, 200);
  }

  // Gérer l'événement input pour filtrer les éléments
  onInput(inputId: string, event: any): void {
    this.searchTerm = event.target.value.toLowerCase();

    // Filtrer les profils en fonction du terme de recherche
    this.filtered_TypeDeCondamnation = this.TypeDeCondamnation.filter(decision =>
      decision.nom.toLowerCase().includes(this.searchTerm)
    );

    // Afficher ou masquer la suggestion "Ajouter" selon qu'il y a une correspondance ou pas
    this.noMatchVisible = this.filtered_TypeDeCondamnation.length === 0 && this.searchTerm.trim() !== ''? true : false;
    console.log('dddddd--->',this.noMatchVisible);
    
  }


  async loadAllProfiles(input_id:string): Promise<void> {

    if (this.filtered_TypeDeCondamnation.length == 0) {
      this.getTypeOfCondamnation()
    }
    
  }
  

  addItemToApi(itemName: string){

    const config: ModalOptions = {
      initialState: {
        label: itemName,
        type: 'decision',
      }
    };

    console.log('openingSuccess');
    return new Promise<string>((resolve, reject) => {
      this.modalRef = this.modalService.show(AddInfractionsComponent, Object.assign({}, config, {class:'modal-lg'}));
      this.modalRef.onHidden.subscribe((value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
      });
    }).then(async (value: string) => {
      console.log('in adddecision', value);

      if (value === "success") {
        this.noMatchVisible = false
        await this.getTypeOfCondamnation()
        

      }else{
      this.alerte.errorNotification("Décision",'Echec de l\'opération !')

    }

    })
  
  }
  selectDecision(item: any,input_id:string): void {
    this.Decision_Judiciaire = item.name

    this.onInput(input_id, { target: { value: item.nom } }); 
    this.isActionVisible = false; 
    this.noMatchVisible = false;
  }

  async ngOnInit() {


    var self = this;
    this.customerService.getIdentificationType().then(res=>{
      this.identification_type = res.data

    })
    try {
     this.getJugement().then((res)=>{
     
      this.GetDocuments()
  
      this.getTypeOfCondamnation()
      this.getCateggorieOfCondamnation()
  
       this.getAllInfrations()
     })

    } catch (error) {

    }
    
   
    
    

    this.jugementService.getAllTypeRepports().then(res=>{
      this.type_jugement_reports = res.data
    })

 

   

    $(document).ready(function(){
      console.log('dddddd rrreeaady');

      self.initializeStepper();

    // table_infractions

    const selectBtn = document.querySelector(".select-btn"),
    items = document.querySelectorAll(".item"),
    selectedItemsTable = document.getElementById("selectedItemsTable")
    const tableBody = document.querySelector(".details_infractionTable tbody") as HTMLTableSectionElement;

  selectBtn.addEventListener("click", () => {
    selectBtn.classList.toggle("open");
  });

  items.forEach(item => {
    item.addEventListener("click", () => {
        item.classList.toggle("checked");

        const itemText = item.querySelector(".item-text").textContent;

        if (item.classList.contains("checked")) {
            const newRow = tableBody.insertRow();
            const cell1 = newRow.insertCell(0);
            const cell2 = newRow.insertCell(1);
              cell1.textContent = itemText;
              cell2.innerHTML = '<i class="fas fa-eye m-t-3"></i>';
            // cell2.textContent = "Some data"; // Vous pouvez remplir cette colonne avec des données supplémentaires si nécessaire
        } else {
            // Supprimez la ligne correspondant à l'élément désélectionné
            const rows = tableBody.getElementsByTagName("tr");
            for (let i = 0; i < rows.length; i++) {
                if (rows[i].cells[0].textContent === itemText) {
                    tableBody.deleteRow(i);
                    break;
                }
            }
        }
    });
  });


  })

 
  }
}
